import {openTelegramLink, retrieveLaunchParams} from "@telegram-apps/sdk-react";

export const shareLink = async (link: string, text?: string): Promise<void> => {
  const lp = retrieveLaunchParams();
  if (lp.platform != "unknown") {
    link = "https://t.me/share/url?url=" + encodeURIComponent(link);
    if (text) {
      link += "&text=" + encodeURIComponent(text);
    }
    openTelegramLink(link);
  } else {
    // navigator share
    if (navigator.share) {
      await navigator.share({
        url: link,
      });
    } else {
      window.open(link, '_blank');
    }
  }
}
